import Layout from "@views/layout";

const communityDashboardScoreRouter = {
    path: "/dashboard/score",
    component: Layout,
    redirect: "/dashboard/score/score-distribution",
    meta: {
        title: "积分看板",
        icon: "el-icon-document",
    },
    children: [
        {
            path: "score-distribution",
            name: "COMMUNITY_DASHBOARD_SCORE_DISTRIBUTION",
            component: () => import("@views/dashboard/score/ScoreDistribution.vue"),
            meta: {
                title: "积分分布",
                keepAlive: false,
            },
        },
         {
            path: "score-trend",
            name: "COMMUNITY_DASHBOARD_SCORE_TREND",
            component: () => import("@views/dashboard/score/ScoreTrend.vue"),
            meta: {
                title: "积分趋势",
                keepAlive: false,
            },
        },
    ],
};

export default communityDashboardScoreRouter;
